module.exports = __webpack_public_path__ + "img/un.5232b1ea.svg";